/**
 * External dependencies
 */
/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';
import { login, jwtLogin } from './controller';

export default (router) => {
    router(`/login`, login, makeLayout, render);

    router(`/jwt-login`, jwtLogin, makeLayout, render);
};


